module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAMAAADnEdnLAAAAM1BMVEX////ljjjyy67srnvnlkvvvZbonl39+fbttonqpm3338/55tn88+z12cTxxKL67OP00rlX9sWUAAAAu0lEQVR4Xu2TO25DMQwENaT+73v/0yYmYFcbFQ7ceRoJGBFLEWD6MF+O7t7vpmUbBHWX+gQ/ZocitVMfx6BKXRgP3clSb3C3dENJEiNw3XorOXTRnQ84t80yueloi9nArZO35zOhJ/T4n65uGep5Dsiyt6sS1Ctppv0y0wfYj+2J6bG80NqDoTW8LlpbUGCZ/V51XWUbdVVt62zHF9UNjkW2wf63vjIezmYhq/27QoNck3KnwN37nv7Dlx+ByQUAS5IsVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pin_aug.png
// module id = 1685
// module chunks = 1